import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"];

  connect() {}

  disconnect() {}

  clear() {
    this.inputTarget.value = ''
  }
}
